import { render, staticRenderFns } from "./ValidationExamen.vue?vue&type=template&id=85ec88b6&scoped=true"
import script from "./ValidationExamen.vue?vue&type=script&lang=js"
export * from "./ValidationExamen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ec88b6",
  null
  
)

export default component.exports